export default "__VITE_ASSET__C1dN5b1f__"